import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { resetTimezone } from '../../util/format-date';

@Pipe({
  name: 'dateFromUTC'
})
export class DateFromUTCPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const format = args[0] ? args[0] : 'mediumDate';
    return formatDate(resetTimezone(new Date(value)), format, 'en-US');
  }

}
